import { DEFAULT_GLOBAL_ERROR_MESSAGE } from 'JS/constants/errors';
import { IGiftCard } from "JS/types/Checkout";
import { ref } from "vue";
import { useGlobalLoader } from "../state/global-loader";
import { useOrderStore } from "../state/order";
import { useServices } from "../services";

/**
 * @param isPayment Whether or not the modal is being used on the payment step
 * @returns an object for managing the state of an apply gift card modal in the automotive scheduler
 */
export function useApplyGiftCardModal(isPayment: boolean) {
	const orderStore = useOrderStore();
	const { paymentService, logService } = useServices();

	const { createChildLoader } = useGlobalLoader();

	const showing = ref(false);
	const loading = createChildLoader('gift-card-modal');
	const error = ref<string | null>(null);

	function open() {
		error.value = null;
		showing.value = true;
	}

	async function apply(giftCard: IGiftCard) {
		loading.value = true;
		error.value = null;

		try {
			const { errorMessage, session } = await paymentService.applyGiftCard({
				...giftCard,
				isPayment,
			});

			if (errorMessage) {
				error.value = errorMessage;
			}

			loading.value = false;
			if (!error.value) {
				showing.value = false;
			}

			orderStore.setSession(session);
		} catch (e) {
			logService.log(e);
			orderStore.setGlobalErrorMessage(DEFAULT_GLOBAL_ERROR_MESSAGE);
			showing.value = false;
		} finally {
			loading.value = false;
		}
	}

	return {
		open,
		apply,
		showing,
		loading,
		error,
	};
}
